import React, { useRef, useState } from 'react'
import { FlashMessage, GlobalLoader, InputField } from '@reactiveonline/reactive_admin_shared-packages'
import LanguagePicker from '../shared/LanguagePicker'

export default function SetPassword({ adminInterfaceLogo, applicationName, invitationPath, invitationToken, resource }) {
  const [password, setPassword]                         = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [passwordValidator, setPasswordValidator]       = useState({})
  const [passwordShown, setPasswordShown]               = useState(false)
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false)
  const [loading, setLoading]                           = useState(false)

  const flashMessageRef = useRef(null)

  const disableSave = !(passwordValidator.length && passwordValidator.number && passwordValidator.uppercase && passwordValidator.lowercase)
  const unmatchedPasswords = (password != passwordConfirmation)

  function handlePassword(event) {
    const value = event.target.value
    let validations = {}

    if (value.length >= 8) {
      validations = { ...validations, length: true }
    }
    if (value.match(/^.*\d.*$/)) {
      validations = { ...validations, number: true }
    }
    if (value.match(/^.*[A-Z].*$/)) {
      validations = { ...validations, uppercase: true }
    }
    if (value.match(/^.*[a-z].*$/)) {
      validations = { ...validations, lowercase: true }
    }

    setPasswordValidator(validations)
    setPassword(value)
  }

  function handleSave(event) {
    if (password.length === 0 && passwordConfirmation.length === 0) {
      flashMessageRef.current.show(Partners.translations.administrator.attributes.no_pass_set, 'error')
    } else if (disableSave) {
      flashMessageRef.current.show(Partners.translations.administrator.attributes.validation_not_passed, 'error')
    } else if (unmatchedPasswords) {
      flashMessageRef.current.show(Partners.translations.administrator.attributes.password_unmatched, 'error')
    } else {
      save()
    }
  }

  const save = () =>{
    setLoading(true)
    const fd = new FormData()

    fd.append('password', password)
    fd.append('password_confirmation', passwordConfirmation)
    fd.append('invitation_token', invitationToken)

    Rails.ajax({
      type: 'PATCH',
      url: invitationPath,
      dataType: 'json',
      data: fd,
      success: res => window.location.href = res.redirectUrl,
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='flex-box flex-column items-center content-center authentication-wrapper'>
        <div className="auth-box">
          <div className="left-side-wrapper">
            <div className="logo">
              <img src={ adminInterfaceLogo } />
            </div>

            <div className='authentication-language-picker-wrapper'>
              <LanguagePicker />
            </div>

            <div className="headline">
              <h1>{ applicationName }</h1>
              <div>{ Partners.translations.administrator.attributes.set_password }</div>
            </div>
            <div className="form m-t-20">
              <div className="row">
                <div className="field">
                  <InputField
                    className='input-field col s12'
                    style={{ position: 'relative' }}
                    label={ Partners.translations.administrator.attributes.password }
                  >
                    <input
                      type={ passwordShown ? "text" : "password" }
                      value={ password }
                      onChange={ handlePassword }
                    />
                  </InputField>
                  { password.length > 0 &&
                    <div className='show_password'>
                      <i className={`pointer fa-light ${passwordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setPasswordShown(prevState => !prevState) } />
                    </div>
                  }
                </div>
                <div className="field" style={{ position: 'relative' }}>
                  <InputField
                    className='input-field col s12'
                    label={ Partners.translations.administrator.attributes.password_confirmation }
                  >
                    <input
                      type={ confirmPasswordShown ? "text" : "password" }
                      value={ passwordConfirmation }
                      onChange={ e => setPasswordConfirmation(e.target.value) }
                    />
                    { passwordConfirmation.length > 0 &&
                      <div className='show_password'>
                        <i className={`pointer fa-light ${confirmPasswordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setConfirmPasswordShown(prevState => !prevState) } />
                      </div>
                    }
                  </InputField>
                </div>

                <div className='field flex-box flex-wrap items-center content-space-between'>
                  <div className={`pass-validator ${passwordValidator.length ? '' : 'invalid'} `}>
                    { Partners.translations.administrator.attributes.password_length }
                  </div>
                  <div className={`pass-validator ${passwordValidator.number ? '' : 'invalid'} `}>
                    { Partners.translations.administrator.attributes.password_number }
                  </div>
                  <div className={`pass-validator ${passwordValidator.uppercase ? '' : 'invalid'} `}>
                    { Partners.translations.administrator.attributes.password_uppercase }
                  </div>
                  <div className={`pass-validator ${passwordValidator.lowercase ? '' : 'invalid'} `}>
                    { Partners.translations.administrator.attributes.password_lowercase }
                  </div>
                </div>

                <div className="field">
                  <div className='button-wrapper flex-box items-center content-center'>
                    <div
                      className={`btn ${(!disableSave && !unmatchedPasswords) ? '' : 'disabled'} `}
                      onClick={ ()=> (!disableSave && !unmatchedPasswords) ? handleSave() : ()=> {} }
                    >
                      { Partners.translations.administrator.attributes.set_password }
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      { loading && <GlobalLoader fullPage/> }

      <FlashMessage ref={ flashMessageRef } />
    </>
  )
}
